import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Admin/Header';
import Tabs from './Admin/Tabs';
import HeaderNew from './ChannelPartner/Header';
import './Layout.css';
import Cookies from 'js-cookie';
import { Box } from '@mui/material';

const Layout = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState('');
  const userType = Cookies.get('user_type'); 

  useEffect(() => {
    const path = location.pathname.split('/')[1];
    setSelectedTab(`/${path}`);
  }, [location]);

  const HeaderComponent = userType === 'admin' ? Header : HeaderNew;

  return (
    <div className="layout-container">
      {userType === 'admin' && (
        <>
          <Header selectedTab={selectedTab} />
          <Tabs selectedTab={selectedTab} onTabChange={setSelectedTab} />
        </>
      )}
      {userType === 'channelpartner' && (
        <>
          <HeaderNew selectedTab={selectedTab} onTabChange={setSelectedTab} />
        </>
      )}
      <div
        className="content-container"
        style={{
          marginLeft: userType === 'admin' ? '200px' : '0',
          height: 'calc(100vh - 64px)', // Ensure content fills the remaining height
          overflowY: 'auto', // Enable scrolling for content
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;